import { Component, Input, OnChanges } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { TabData } from '@ddt-web/data-service';
import { UrlRedirectService, UrlService } from '@ddt-web/url';
import * as get from 'lodash/get';

@Component({
	selector: 'ate-indicator-column-chart',
	templateUrl: './indicator-column-chart.component.html',
	styleUrls: ['./indicator-column-chart.component.scss']
})
export class IndicatorColumnChartComponent implements OnChanges {
	public portfolioName: string;
	public portfolioValue: string;
	public medianValue: string;
	public sectionTitle: string;
	public peerGroup: string;
	public minValue: string;
	public maxValue: string;
	public disclaimer: string;
	public stockDisclaimer: string;
	public disclaimer2: string;
	public stockDisclaimer2: string;
	public customAttributes: any = {};
	@Input() public data: TabData;
	@Input() public selectedPortfolioIndex: number;
	@Input() public showDisclaimers: boolean = true;
	@Input() public showPeerComparison: boolean = true;

	constructor(
		private urlService: UrlService,
		private urlRedirectService: UrlRedirectService,
		private contentService: ContentService
	) {
		this.stockDisclaimer = this.contentService.get('PEER_GROUP_DISCLAIMER', 'The portfolio and the peer group are <strong>$PEER_GROUP$</strong>.');
		this.stockDisclaimer2 = this.contentService.get('PEER_GROUP_DISCLAIMER_CONT', '(between $MIN_VALUE$% and < $MAX_VALUE$% invested in equities)');
	}

	public ngOnChanges(): void {
		if (this.data && get(this.data, 'tableData[0].cells[0]')) {
			this.sectionTitle = this.data.tableData[0].firstColumnTitle.formattedValue;
			this.portfolioName = this.data.tableData[0].portfolioData[this.selectedPortfolioIndex].formattedValue;
			this.portfolioValue = this.data.tableData[0].cells[this.selectedPortfolioIndex][0].formattedValue;
			if (this.showPeerComparison) {
				this.medianValue = this.data.tableData[0].cells[this.selectedPortfolioIndex][1].formattedValue;
				this.peerGroup = this.data.tableData[0].cells[this.selectedPortfolioIndex][2].formattedValue;
			} else {
				this.customAttributes.hidePlotLine = true;
			}
			if (this.showDisclaimers) {
				this.minValue = this.data.tableData[0].cells[this.selectedPortfolioIndex][3].formattedValue || '0';
				this.maxValue = this.data.tableData[0].cells[this.selectedPortfolioIndex][4].formattedValue;
				this.disclaimer = this.contentService.getSubstitutedValuesString(this.stockDisclaimer, new Map([['$PEER_GROUP$', this.peerGroup]]));
				this.disclaimer2 = this.contentService.getSubstitutedValuesString(this.stockDisclaimer2, new Map([['$MIN_VALUE$', this.minValue], ['$MAX_VALUE$', this.maxValue]]));
			}
		}
	}

	public redirectToPeerComparison(): void {
		this.urlRedirectService.redirectToPeerComparison(this.urlService.getPortfolioIds());
	}
}
